export enum TeamLifecyclePeriodTaskType {
	ProlongTeam,
	CheckRetentionPeriod
}